<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원관리</span>
            <span class="txt">
                센터에 등록한 회원님을 검색하실 수 있으며, 회원님의 성함을 눌러 이용권 등록 및 마일리지 등록 등 회원님의
                다양한 설정을 진행하실 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div style="display: flex; gap: 28px">
                <div class="photo-info-card">
                    <img
                        class="photo"
                        :src="customerInfo.imageUrl === null ? '/img/icons/no_photo.jpg' : customerInfo.imageUrl"
                        alt="사진"
                    />
                    <div class="info-txt">
                        <span class="txt name">{{ customerInfo.name + ` (${customerInfo.attendNo})` }}</span>
                        <span class="txt">{{ customerInfo.phone | phoneNumberFilter }}</span>
                        <span class="txt">{{ convertTeamGroupsToString(customerInfo.centerCustomerTeamGroups) }}</span>
                        <span v-if="customerInfo.centerLocker" class="txt">
                            {{ customerInfo.centerLocker.lockerGroupName }} {{ customerInfo.centerLocker.lockerNo }}번
                        </span>
                        <span v-else="customerInfo.centerLocker" class="txt">-</span>
                    </div>
                    <span v-if="customerInfo.status === 'V'" class="icon green">유효</span>
                    <span v-if="customerInfo.status === 'E'" class="icon red">만료</span>
                    <span v-if="customerInfo.status === '-'" class="icon gray">잠재</span>
                    <span v-if="customerInfo.status === 'H'" class="icon yellow">홀딩</span>
                    <!--<button class="send-btn">Send authentication code</button>-->
                </div>
                <div class="d-flex flex-column" style="margin-top: 35px">
                    <button
                        v-if="hasMessageEvent && customerInfo.mktAgreeSms"
                        class="com-btn white"
                        @click="routing('messageSend', customerInfo)"
                    >
                        메시지 발송
                    </button>
                    <button
                        v-show="isAllowed('ME', 6)"
                        class="com-btn white"
                        style="margin-top: 10px"
                        @click="showContractSendPopup()"
                    >
                        계약서 발송
                    </button>
                    <button
                        v-if="showPaymentLinkBtn"
                        class="com-btn deep-blue"
                        style="margin-top: 10px"
                        @click="togglePayLinkPop(true)"
                    >
                        결제링크전송
                    </button>
                </div>
                <div class="info-card">
                    <div class="info-txt">
                        <span class="txt name">최근 수업일</span>
                        <span class="txt">{{ lastLessonDaysAgo }}일전</span>
                        <span class="txt">마지막 출석: {{ customerInfo.latestLessonAt | dateFormatFilter }}</span>
                    </div>
                </div>
            </div>
            <div class="com-tab">
                <button @click="onClickRouter('/madmin/member/info')">기본정보</button>
                <button @click="onClickRouter('/madmin/member/payment')">결제내역</button>
                <button @click="onClickRouter('/madmin/member/cancel')">예약/취소내역</button>
                <button @click="onClickRouter('/madmin/member/attend')">입장/출결내역</button>
                <button @click="onClickRouter('/madmin/member/mileage')">마일리지</button>
                <button
                    @click="
                        checkAllowedClick('MB', 3, () => {
                            onClickRouter('/madmin/member/advice');
                        })
                    "
                >
                    상담내역
                </button>
                <button @click="onClickRouter('/madmin/member/message')">메시지발송내역</button>
                <button class="on">계약서발송내역</button>
            </div>

            <div class="com-table-content">
                <div class="com-btn-area">
                    <div class="left-box">
                        <span class="tit">발송내역</span>
                    </div>
                    <div class="right-box">
                        <span class="txt">
                            총
                            <span class="blue">{{ contractSendListPagingInfo.totalItems }}</span>
                            개
                        </span>
                    </div>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 245px" />
                        <col style="width: 285px" />
                        <col style="width: 155px" />
                        <col style="width: 155px" />
                        <col style="width: 155px" />
                        <col style="width: 170px" />
                        <col style="width: 170px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <div class="com-check">
                                    <input
                                        id="check-all"
                                        v-model="selectedAll"
                                        name="check-all"
                                        type="checkbox"
                                        @click="checkedAll"
                                    />
                                    <label for="check-all"></label>
                                </div>
                            </th>
                            <th>
                                <button
                                    :class="
                                        contractSendListSortColumn == 'cs_cre_dt'
                                            ? contractSendListSortType == 'DESC'
                                                ? ''
                                                : 'degree'
                                            : ''
                                    "
                                    @click="onClickSendDt"
                                >
                                    발송일시
                                </button>
                            </th>
                            <th>계약서명</th>
                            <th>발송인</th>
                            <th>서명기한</th>
                            <th>상태</th>
                            <th>
                            발송금액
                        </th>
                        <th>
                                <button
                                    :class="
                                        contractSendListSortColumn == 'cs_status_dt'
                                            ? contractSendListSortType == 'DESC'
                                                ? ''
                                                : 'degree'
                                            : ''
                                    "
                                    @click="onClickProcessDt"
                                >
                                    처리일시
                                </button>
                            </th>
                            <th>더보기</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(t, index) in contractSendList" :key="index">
                            <td>
                                <div class="com-check">
                                    <input
                                        :id="t.cst_id"
                                        v-model="selected"
                                        :value="index"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label :for="t.cst_id"></label>
                                </div>
                            </td>
                            <td>{{ t.cs_cre_dt | timestampFilter2 }}</td>
                            <td>
                            <div style='width: 20vw; margin-right: auto; margin-left: auto'>
                                    <div
                                        style="text-decoration: underline; cursor: pointer"
                                        @click="onShowContract(index)"
                                    >
                                        {{ t.ct_contract_title }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                {{ t.c_center_name }}
                            </td>
                            <td>
                                {{ t.cs_deadline_dt | timestampFilter2 }}
                            </td>
                        <td :style='"color: " + `${t.cs_status == "R" ? "#00C7E5" : (t.cs_status == "C" || t.cs_status == "N" ? "#f64444" : "black")}`'>
                                {{ t.cs_status | getContractSendStatus }}
                            </td>
                            <td>
                          300원
                        </td>
                        <td>
                                {{ t.cs_status_dt | timestampFilter2 }}
                            </td>
                            <td>
                                <el-dropdown class="view-more-dropdown" @command="onClickViewMore">
                                    <el-button type="primary" trigger="click">...</el-button>
                                    <el-dropdown-menu>
                                        <el-dropdown-item
                                            :command="`${it.type + '-' + index}`"
                                            v-for="it in selectViewMore"
                                            :key="it.type"
                                        >
                                            {{ it.name }}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </td>
                        </tr>
                        <tr v-if="contractSendList.length === 0">
                            <td colspan="100">등록된 내역이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="com-btn-area table-bottom-func">
                    <div class="left-box">
                        <button class="com-btn excel" @click="excelDownload()">엑셀 다운로드</button>
                    </div>
                    <div class="right-box">
                        <select-form
                            :select-data="[...sortTypeList]"
                            :select-value="[...sortTypeValueList]"
                            :selected-value="contractSendListPagingInfo.limit"
                            class="float-right"
                            @update:set="changeLimit"
                        ></select-form>
                    </div>
                </div>
                <b-pagination
                    v-model="contractSendListPagingInfo.page"
                    :per-page="contractSendListPagingInfo.limit"
                    :total-rows="contractSendListPagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event)"
                ></b-pagination>
            </div>
        </template>
        <contract-send-dlg
            v-if="contractSendPop"
            :show="contractSendPop"
            :info="contractSendInfo"
            :close="handleCloseContractSend"
            :charge="handleCharge"
            :paymentLinkSend="handlePaymentLinkSend"
        ></contract-send-dlg>

        <contract-preview-dlg
            v-if="contractPreviewPop"
            :show="contractPreviewPop"
            :templateSendId="selectedTemplateSendId"
            :close="handleCloseContractPreview"
        ></contract-preview-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { Utils } from '@/assets/js/utils';
import { pagingInfo } from '@/assets/js/common';
import ContractSendDlg from '../../../components/ContractSendDlg';
import ContractPreviewDlg from '../../../components/ContractPreviewDlg';
import XLSX from 'xlsx';
import { convertImgToDataURLviaCanvas } from '@/assets/js/common';

export default {
    name: 'memberPayment',
    mixins: [MixinAllowedMenu],
    components: {
        ContractSendDlg,
        ContractPreviewDlg,
    },
    props: {},
    computed: {
        today() {
            return moment().format('YYYY-MM-DD');
        },
        centerStaffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
        showPaymentLinkBtn() {
            return this.isAllowed('LE', 1);
        },

        lastLessonDaysAgo() {
            if (this.customerInfo.latestLessonAt) {
                return moment().startOf('day').diff(moment(this.customerInfo.latestLessonAt).startOf('day'), 'days');
            }

            return '-';
        }
    },
    async mounted() {
        await this.allowedMenuEvent.init();
        await this.init();
    },
    data() {
        return {
            hasMessageEvent: false, // 메시지 계약되었을시..
            isLoading: false,
            centerId: this.$route.params.id,
            customerId: this.$route.query.customerId,
            prevPagingStep: this.$route.query.prevPagingStep,
            customerInfo: {}, // 회원 정보
            contractSendList: [],
            contractSendListPagingInfo: { ...pagingInfo },
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            selectedAll: false,
            selected: [],

            selectViewMore: [
                { type: 1, name: '업데이트' },
                { type: 2, name: '다운로드' },
                { type: 3, name: '발송취소' },
                { type: 4, name: '기한연장' },
            ],

            contractSendListSortType: 'DESC',
            contractSendListSortColumn: 'cs_cre_dt',

            payLinkPop: false,
            centerInfo: {},
            staffId: '',

            contractSendPop: false,
            contractSendInfo: {},

            contractPreviewPop: false,
            selectedTemplateSendId: 0,
        };
    },
    methods: {
        routing(toName, checkedUserData) {
            const routingData = [];
            console.log(checkedUserData);
            // checkedUserData.forEach((param) => {
            const tempValue = {
                ...checkedUserData,
            };
            routingData.push(tempValue);
            // });
            this.$router.push({
                name: toName,
                params: { data: routingData },
            });
        },

        checkMessageEvent() {
            return api
                .get('/admin/api/center/ftcontract/sms')
                .then((res) => {
                    this.hasMessageEvent = JSON.parse(res.data);
                })
                .catch((error) => {
                    this.hasMessageEvent = false;
                });
        },

        // 초기화
        async init() {
            this.contractSendListPagingInfo.page = 1;
            this.isLoading = true;
            this.staffId = parseInt(this.$store.getters['auth/staffId']);

            Promise.allSettled([
                this.fetchCustomerDetail(), // 회원 정보 가져오기
                this.fetchContractSendList(),
                this.getCenterInfo(),
            ]); // 로그인한 센터 정보 가져오기
            this.isLoading = false;

            this.checkMessageEvent();
        },

        checkedAll() {
            // 전체 선택 기능
            this.selected = [];
            if (!this.selectedAll) {
                for (const i in this.contractSendList) {
                    this.selected.push(i);
                }
            }
        },

        onShowContract(index) {
            this.selectedTemplateSendId = this.contractSendList[index].cst_id;

            this.contractPreviewPop = true;
        },

        handleCloseContractPreview() {
            this.contractPreviewPop = false;
        },

        // Excel Download
        async excelDownload() {
            const { data } = await this.sendGetContractSendList();

            const excelDownloadArray = [];
            data.items.forEach((item) => {
                const temp = {};
                temp['발송일시'] = this.$options.filters.timestampFilter2(item.cs_cre_dt);
                temp['계약서명'] = item.ct_contract_title;
                temp['발송인'] = item.c_center_name;
                temp['서명기한'] = this.$options.filters.timestampFilter2(item.cs_deadline_dt);
                temp['상태'] = this.$options.filters.getContractSendStatus(item.cs_status);
                temp['처리일시'] = this.$options.filters.timestampFilter2(item.cs_status_dt);

                excelDownloadArray.push(temp);
            });
            const ws = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [{ wch: 30 }, { wch: 20 }, { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 }];
            ws['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            ws['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Contract Send List');
            XLSX.writeFile(wb, `Contract Send List ${new Date().toLocaleDateString().toString()}.xlsx`);
        },

        // 한 페지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.contractSendListPagingInfo.limit = val;
            this.fetchContractSendList();
        },

        // 회원 정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();
                this.customerInfo = data;
                for (let i in this.customerInfo.centerLockers) {
                    if (this.customerInfo.centerLockers[i].lockerStatus != 'F') {
                        this.customerInfo.centerLocker = this.customerInfo.centerLockers[i];
                        break;
                    }
                }
            } catch (error) {
                alert('회원 정보를 검색하는 동안 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}`);
        },

        async fetchContractSendList() {
            try {
                this.isLoading = true;

                const { data } = await this.sendGetContractSendList();
                this.setPageParams(data);
                this.contractSendList = data.items;

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        sendGetContractSendList() {
            let params = {
                sortColumn: this.contractSendListSortColumn,
                sortType: this.contractSendListSortType,
                ...this.contractSendListPagingInfo,
            };

            return api.get(`/admin/api/center/contract/list/recipient/${this.customerId}/0`, {
                params,
            });
        },

        // 페지 이동
        onClickRouter(path) {
            this.$router.push({
                path: `${path}/${this.centerId}`,
                query: {
                    customerId: this.customerId,
                    prevPagingStep: this.prevPagingStep,
                },
            });
        },

        // 페지 변경 Handler
        handlerPagenation(event) {
            this.contractSendListPagingInfo.page = event;
            this.fetchContractSendList();
        },

        // timestampTZ -> date (년-월-일)
        timestampFilter(value) {
            const b = value.split(/\D/);
            b[1] -= 1;
            b[6] = b[6].substr(0, 3);
            const d = new Date(Date.UTC(...b));
            return `${d.getFullYear()}-${this.addZero(d.getMonth() + 1)}-${this.addZero(d.getDate())}`;
        },

        addZero(target) {
            // 9 이하의 숫자는 0 붙이기
            const num = parseInt(target);
            const str = num > 9 ? num : `0${num}`;
            return str.toString();
        },

        // 회원 정보 카드에 나타낼 회원 Group 이름 만들기
        convertTeamGroupsToString(teamGroups) {
            if (teamGroups === undefined) {
                return '';
            }
            if (teamGroups.length === 1) {
                // Group이 1개일 경우
                return teamGroups[0].centerCustomerTeamName;
            } else if (teamGroups.length === 0) {
                // Group이 없을 경우
                return '-';
            } else if (teamGroups.length > 1) {
                // Group이 여러개일 경우
                return `${teamGroups[0].centerCustomerTeamName} 외 ${teamGroups.length - 1}`;
            }
            return '';
        },

        // 결제수단_금액 가공
        convertBillInfo(billInfo) {
            // ex) C_1300000|L_240000 결제수단_금액 으로 들어오는 string 값을 가공
            const result = '-';
            const billInfoArray = [];
            if (billInfo === undefined) {
                // undeifiend인 경우
                return;
            }
            if (billInfo !== null) {
                const temp1 = billInfo.split('|');
                temp1.forEach((bill) => {
                    const temp2 = bill.split('_');
                    let payType = '';
                    switch (temp2[0]) {
                        case 'C':
                            payType = '[카드]';
                            break;
                        case 'L':
                            payType = '[캐시]';
                            break;
                        case 'B':
                            payType = '[계좌이체]';
                            break;
                        case 'M':
                            payType = '[마일리지 설정]';
                            break;
                        case 'E':
                            payType = '[기타]';
                            break;
                        case 'T':
                            payType = '[핏페이]';
                            break;
                        case 'U':
                            payType = '[핏페이]';
                            break;
                        default:
                            payType = '[-]';
                    }
                    const result = `${payType} ${this.getNumberFormat(parseInt(temp2[1]))}$`; // ex) [Card] 240,000원 으로 만듦
                    billInfoArray.push(result);
                });
                return billInfoArray;
            }
            billInfoArray.push(result);
            return billInfoArray;
        },

        // 금액에 , 넣기
        getNumberFormat(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // Paging Param 설정
        setPageParams(data) {
            this.contractSendListPagingInfo.totalPages = data.meta.totalPages;
            this.contractSendListPagingInfo.page = data.meta.currentPage;
            this.contractSendListPagingInfo.totalItems = data.meta.totalItems;
            this.contractSendListPagingInfo.itemCount = data.meta.itemCount;
        },

        // 이용권명 컬럼 클릭시
        onClickSendDt() {
            this.contractSendListSortColumn = 'cs_cre_dt';
            if (this.contractSendListSortType === '' || this.contractSendListSortType === 'DESC') {
                this.contractSendListSortType = 'ASC';
            } else {
                this.contractSendListSortType = 'DESC';
            }
            this.fetchContractSendList();
        },

        // 유효기간 컬럼 클릭시
        onClickProcessDt() {
            this.contractSendListSortColumn = 'cs_status_dt';
            if (this.contractSendListSortType === '' || this.contractSendListSortType === 'DESC') {
                this.contractSendListSortType = 'ASC';
            } else {
                this.contractSendListSortType = 'DESC';
            }
            this.fetchContractSendList();
        },

        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        showContractSendPopup() {
            this.contractSendInfo = {
                centerId: this.centerId,
                centerName: this.centerInfo.centerName,
                customerId: this.customerId,
                customerName: this.customerInfo.name,
                customerPhone: this.customerInfo.phone,
                templateType: 'M',
            };
            this.contractSendPop = true;
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        togglePayLinkPop(open) {
            if (open && !this.isAllowed('SA', 'FITPAY')) {
                if (
                    confirm(
                        'This feature is available only after signing up for FitPay.\n Would you like to apply now?'
                    )
                ) {
                    this.$router.push({ path: `/madmin/setting/center/${this.centerId}/fitpay` });
                }

                return;
            }
            this.payLinkPop = open;
        },

        handleCloseContractSend() {
            this.contractSendPop = false;
        },

        handleCharge() {
            this.contractSendPop = false;
        },

        handlePaymentLinkSend() {
            this.contractSendPop = false;

            this.fetchContractSendList();
        },

        getTemplate(templateSendId) {
            return api.get(
                `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/send/${templateSendId}`
            );
        },

        getElementItemHtml(item, senderImageRawData, recipientImageRawData) {
            let html = ``;
            let index = 0;

            html += `
              <div class='contract-content-info'>
                    <div class='contract-title-input' style='margin-bottom: 20px; background-color: white'>
                        ${item.e_contract_title}
                    </div>
                    <div class='contract-info-title'>수신인 정보</div>
                    <div style='display: flex'>
                        <div class='contract-info-sub-title title'>이름</div>
                        <div class='contract-info-sub-title'>${item.recipientName}</div>
                    </div>
                    <div style='display: flex'>
                        <div class='contract-info-sub-title title'>연락처</div>
                        <div class='contract-info-sub-title'>${item.recipientPhone}</div>
                    </div>`;
            if (item.centerContractId > 0 && item.centerProdId > 0) {
                const ticketInfo = JSON.parse(item.ticketInfo);
                if (ticketInfo && ticketInfo.length > 0) {
                    html += `<div class='contract-info-title'>이용권 정보</div>`;

                    ticketInfo.map((t) => {
                        html +=
                            `
                            <div class='ticket-container'>
                                <div class='ticket-box'>
                                    <div class='ticket-box-title'>` +
                            t.title +
                            `</div>
                                    <div class='ticket-box-info'>
                                        <div style='flex: 1'>
                                            ` +
                            t.period +
                            `
                                        </div>
                                        <div>
                                            ` +
                            (t.price + '원') +
                            `
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                    });
                }
            }

            html += `<div class='contract-info-title'>약관</div>`;

            if (item.templateInfo) {
                item.templateInfo.map((it, i) => {
                    html += `<div style='padding: 10px 10px 0 10px'>`;

                    const content = it.content.replace(new RegExp('\n', 'g'), '<br>');

                    if (it.type == 1) {
                        html += `
                        <div>
                            <div class='contract-info-sub-title' style='display: flex'>
                                <div style='flex: 1;'>${it.title}</div>
                            </div>
                            <div class='contract-info-sub-title area' style='background-color: transparent; width: 100%'>${content}</div>
                        </div>
                      `;
                    } else {
                        html += `
                        <div style='display: flex'>
                            <div style='flex: 1;'>
                                <div class='contract-info-sub-title' style='display: flex'>
                                    <div style='flex: 1;'>${it.title}</div>
                                </div>
                                <div class='contract-info-sub-title area' style='background-color: transparent; width: 100%'>${content}</div>`;

                        it.options.map((jt, j) => {
                            html += `
                            <div style='display: flex; align-items: center; margin-top: 10px'>
                                <div class='com-check'>
                                    <input
                                        :id='agree-check-${index}-${i}-${j}'
                                        name='check-c1'
                                        ` + (jt.checked ? "checked" : "") + `
                                        type='checkbox'
                                        disabled
                                    />
                                    <label :for='agree-check-${index}-${i}-${j}' class='agree-option'></label>
                                </div>
                                <div class='agree-option-input'>${jt.title}</div>
                            </div>
                          `;
                        });

                        html += `
                            </div>
                        </div>`;
                    }

                    html += `</div>`;
                });
            }

            html +=
                `
                    <div style='display: flex'>
                        <div class='contract-info-title' style='flex: 1;'>${this.$options.filters.dateFormatFilter2(
                            item.sendTime
                        )}</div>
                        <div style='width: 300px; margin-top: 40px;'>
                            <div style='display: flex; align-items: center'>
                                <div class='contract-info-person'>수신인</div>
                                <img class='contract-info-signature' src='` +
                recipientImageRawData +
                `' />
                            </div>
                            <div style='display: flex; align-items: center; margin-top: 10px;'>
                                <div class='contract-info-person'>발신인</div>
                                <img class='contract-info-signature' src='` +
                senderImageRawData +
                `' />
                            </div>
                        </div>
                    </div>
                  </div>
              `;

            return html;
        },

        getElementHtml(list, callback) {
            const item = list[0];
            let senderImageRawData = item.senderSignImageUrl;
            let recipientImageRawData = item.recipientSignImageUrl;
            // const html = this.getElementItemHtml(item, senderImageRawData, recipientImageRawData);
            // callback(html);
            convertImgToDataURLviaCanvas(item.senderSignImageUrl, (imageRawData) => {
                senderImageRawData = imageRawData;

                convertImgToDataURLviaCanvas(item.recipientSignImageUrl, (imageRawData) => {
                    recipientImageRawData = imageRawData;

                    const html = this.getElementItemHtml(item, senderImageRawData, recipientImageRawData);

                    callback(html);
                });
            });
        },

        getPDFContent(index, returnBuffer = false) {
            return Promise.all([this.getTemplate(this.contractSendList[index].cst_id)]).then((response) => {
                console.log(index + ' 클릭 ======');
                if (response && response.length > 0) {
                    const list = response[0].data;
                    console.log(list);
                    let element = document.createElement('div');
                    element.style.padding = '20px';

                    this.getElementHtml(list, (html) => {
                        element.innerHTML = html;

                        let opt = {
                            filename: this.contractSendList[index].ct_contract_title + '.pdf',
                            enableLinks: true,
                            image: { type: 'jpeg', quality: 0.98 },
                            html2canvas: {
                                scale: 3,
                                y: -40,
                                scrollY: 0,
                                useCORS: true,
                                width: 800,
                                height: 1130,
                                letterRendering: true,
                            },
                            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                        };

                        if (returnBuffer) {
                            return html2pdf().from(element).set(opt).output();
                        } else {
                            return html2pdf().from(element).set(opt).save();
                        }
                    });
                }
            });
        },

        async onClickViewMore(command) {
            const data = command.split('-');
            const index = data[1];
            if (data[0] != 2 && this.contractSendList[index].cs_status == 'P') {
                alert('기간만료된 계약서입니다.');
                return;
            }
            if (data[0] != 2 && this.contractSendList[index].cs_status == 'R') {
                alert('이미 완료된 계약서입니다.');
                return;
            }
            if (data[0] != 2 && this.contractSendList[index].cs_status == 'N') {
                alert('이미 거절된 계약서입니다.');
                return;
            }

            if (data[0] == 1) {
                this.fetchContractSendList();
            } else if (data[0] == 2) {
                this.getPDFContent(index);
            } else if (data[0] == 3) {
                if (this.contractSendList[index].cs_status == 'S') {
                    if (confirm('계약서 발송을 취소 하시겠습니까?')) {
                        const data = await api.put(
                            `/admin/api/center/contract/send/cancel/${this.contractSendList[index].cst_id}`
                        );
                        if (data) {
                            alert('취소 요청이 접수되었습니다.');
                            this.fetchContractSendList();
                        }
                    }
                } else if (this.contractSendList[index].cs_status == 'C') {
                    alert('이미 취소된 계약서입니다.');
                } else {
                    alert('이미 발송된 계약서입니다.');
                }
            } else if (data[0] == 4) {
                const index = data[1];
                if (this.contractSendList[index].cs_status == 'S') {
                    if (
                        confirm(
                            '서명기한을 연장할 경우 연장된 기한으로 해당 계약서가 자동으로 재전송됩니다. 진행하시겠습니까?'
                        )
                    ) {
                        const data = await api.put(
                            `/admin/api/center/contract/expand/deadline/${this.contractSendList[index].cst_id}/1`
                        );
                        if (data) {
                            alert('취소 요청이 접수되었습니다.');
                            this.fetchContractSendList();
                        }
                        alert('계약서가 연장된 기한으로 재발송되었습니다.');
                    }
                } else if (this.contractSendList[index].cs_status == 'C') {
                    alert('이미 취소된 계약서입니다.');
                } else {
                    alert('이미 발송된 계약서입니다.');
                }
            }
        },
    },
};
</script>
<style lang="scss"></style>
